import InviteDialog from './InviteDialog';

export default InviteDialog;
